import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import {
  TableAction,
  StatusFilter,
  Table,
  MobileTable,
  StatusHandler,
  SubmissionStatus,
  ArrayChecker,
} from '../../../components'
import { fetchBlogs } from '../../../features/organization/blogs/slice'
import service from '../../../features/blog/service'
import { SystemProvider } from '../../../features/system/provider'

function matchBlogToTable(blogs, language){
  let result = []

  if(blogs && blogs.length > 0){
    for (let index = 0; index < blogs.length; index++) {
      const blog = blogs[index];
      const {id, title, type, category, submission} = blog
      result.push({
        id,
        title: title?.[language.name],
        type,
        category: category?.[language.name],
        visibility: '',
        submission
      })
    }
  }

  return result
}

const PageContent = () => {
  const dispatch = useDispatch()
  const [requesting, setRequesting] = React.useState(false)
  const blogs = useSelector(state => state.organizationBlogs.data)
  const status = useSelector(state => state.organizationBlogs.status)
  const error = useSelector(state => state.organizationBlogs.error)
  const language = useSelector(state => state.system.language)
  const [selectedRows, setSelectedRows] = React.useState([])

  React.useEffect(() => {
    dispatch(fetchBlogs())

    // eslint-disable-next-line
  }, [])

  const tableData = useMemo(() => matchBlogToTable(blogs, language), [blogs, language])
  const tableColumns = useMemo(
    () => [
      {
        Header: 'Title',
        accessor: 'title',
        // Cell: (props) => {
        //   const id = props.data[props.row.index].id
        //   return (
        //   <Link to={`/dashboard/blog/update/${id}`}>
        //     {props.value}
        //   </Link>
        //   )
        // },
      },
      {
        Header: 'Categories',
        accessor: 'category',
      },
      // {
      //   Header: 'Visibility',
      //   accessor: 'visibility',
      // },
      {
        Header: 'Submission',
        accessor: 'submission',
        Cell: ({ value }) => <SubmissionStatus value={value}/>
      },
      {
        Header: 'Action',
        accessor: 'id',
        Cell: (props) => {
          return (
            <div className="flex flex-col space-y-2">
              <Link to={`/blog/${props.value}/detail`} className="link">View</Link>
              <Link to={`/dashboard/blog/update/${props.value}`} className="link">Edit</Link>
            </div>
          )
        },
      }
    ],
    []
  )

  const handleCheckbox = (rows) => setSelectedRows(rows)

  const handleBulkAction = (form) => {
    if(form.action === 'delete' && selectedRows.length > 0){
      let c = window.confirm("Apakah anda yakin akan menghapus data?")
      if(c){
        setRequesting(true)
        let count = 0

        const handleRequestDone = () => {
          count++
          if(count === selectedRows.length){
            setRequesting(false)

            // trigger re-fetch blog
            dispatch(fetchBlogs())
          }
        }

        for (let index = 0; index < selectedRows.length; index++) {
          const row = selectedRows[index];
          const id = row.original.id
          console.log('delete blog with this id: ', id)

          service.delete(id)
          .then(res => console.log(res))
          .catch(err => console.log(err))
          .then(() => {
            console.log(id, ' deleted.')
            handleRequestDone()
          })
        }
      }
    }
  }

  return (
    <StatusHandler
      status={status}
      error={error}
      onRetry={() => dispatch(fetchBlogs())}
    >
      <ArrayChecker data={tableData}>
        <div className="mb-5 lg:mb-8">
          <StatusFilter />
        </div>

        <div className="mb-8">
          <TableAction
            onSubmit={handleBulkAction}
            requesting={requesting}
          />
        </div>

        <hr className="mb-8 lg:mb-4" />

        <SystemProvider>
          {/* Desktop Table */}
          <div className="hidden lg:block mb-12">
            <Table
              data={tableData}
              columns={tableColumns}
              withCheckbox
              handleCheckbox={handleCheckbox}
            />
          </div>

          {/* Mobile Table */}
          <div className="lg:hidden mobile-fullwidth mb-12">
            <MobileTable
              data={tableData}
              columns={tableColumns}
              withCheckbox
            />
          </div>
        </SystemProvider>
      </ArrayChecker>
    </StatusHandler>
  )
}

export { PageContent }
